import { Players } from '../../../../shared/api-models/admin';

export class PlayersView extends Players {
    lastCheckin: string;
}